import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map } from 'rxjs';

import { NavService } from '@smw/navigation-front';
import { UserStore } from '@smw/stores-front';

/** This guard automatically redirect users to the onboarding page if they didn't achieved the onboarding before. */
export const onboardingGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const nav = inject(NavService);
  const urlToAccess = state.url;

  if (urlToAccess.includes(nav.routeOf('collaborator.onboarding'))) {
    return true;
  }

  return userStore.loadUser().pipe(
    map(() => {
      const user = userStore.user();
      if (user?.completedOnboarding === false) {
        router.navigateByUrl(nav.routeOf('collaborator.onboarding'));
        return false;
      }
      return true;
    }),
  );
};
